// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import JpgOutlinedSvg from "@fishx/icons-svg/es/asn/JpgOutlined";
import FishxIcon from '../components/FishxIcon';

var JpgOutlined = function JpgOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: JpgOutlinedSvg
  }));
};

JpgOutlined.displayName = 'JpgOutlined';
export default React.forwardRef(JpgOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/JpgOutlined.js
// module id = 3008
// module chunks = 0